const config = require('./config')
const {
  getLanguageCodeByLocale,
  getSupportedLanguageCodes,
  getSupportedLocaleCodesByLanguage,
} = require('./locale')

const parseDomain = domain => {
  const [subDomains, topLevelDomains] = domain.split('.ticketswap.')
  const subDomainArray = subDomains ? subDomains.split('.') : undefined
  const topLevelDomainArray = topLevelDomains ? topLevelDomains.split('.') : undefined
  const isDev = Boolean(topLevelDomainArray) && topLevelDomainArray[0].includes('pizza')

  return {
    domain: 'ticketswap',
    topLevelDomains: topLevelDomainArray,
    ngrokName: isDev ? subDomainArray[1] : undefined,
    domainLocale: isDev ? subDomainArray[0] : undefined,
    isDev,
  }
}

const getHostnameByLocale = (locale, req) => {
  let hostname = ''

  if (req) {
    hostname = req.headers.host
  } else {
    hostname =
      typeof window !== 'undefined' ? window.location.hostname : process.env.NEXT_PUBLIC_BASE_URL
  }

  if (hostname.indexOf('localhost') !== -1) {
    return `localhost:1666`
  }

  let language = getLanguageCodeByLocale(locale)
  const fallbackLocale = language ? locale : 'en'

  if (!language) {
    language = 'en'

    console.error(`Forced to English. Locale: ${locale}}`)
  }

  const localeConfig = config[language].supportedLocales[fallbackLocale]

  const { isDev, ngrokName } = parseDomain(hostname)

  if (isDev) {
    return `${localeConfig.devDomain}.${ngrokName}.ticketswap.pizza`
  }

  return localeConfig.domain
}

const getUrlByLocale = (locale, req) => {
  let hostname = getHostnameByLocale(locale, req)
  let path = ''

  if (req) {
    path = req.url
  } else {
    path = typeof window !== 'undefined' ? window.location.pathname : ''
  }

  if (hostname.indexOf('localhost') !== -1) {
    return `http://${hostname}${path}`
  }

  return `https://${hostname}${path}`
}

const getDomainMap = () => {
  const languages = getSupportedLanguageCodes()
  const domains = {}

  languages.forEach(languageCode => {
    const supportedLocales = config[languageCode].supportedLocales
    Object.keys(supportedLocales).forEach(locale => {
      domains[locale] = supportedLocales[locale]
    })
  })

  return domains
}

const getLocaleByDomain = domain => {
  if (domain.indexOf('localhost') !== -1) {
    return 'en'
  }

  const domainMap = getDomainMap()
  const { isDev, domainLocale } = parseDomain(domain)

  if (isDev) {
    return Object.keys(domainMap)
      .filter(locale => {
        return domainMap[locale].devDomain === domainLocale
      })
      .pop()
  }

  return Object.keys(domainMap)
    .filter(locale => {
      return domainMap[locale].domain === domain
    })
    .pop()
}

const getDesiredDomainByLanguage = (domain, language) => {
  // Get all supported locales of the browser language
  const supportedLocales = getSupportedLocaleCodesByLanguage(language)

  // Get the locale region of the current domain
  const domainLocale = getLocaleByDomain(domain)

  if (!domainLocale) return null

  const domainRegion = domainLocale.split('-')[1]

  /**
   *   Check if one of the regions of the supported locales matches the region of the current domain.
   *   Example:
   *   - supportedLocales: fr-FR, fr-BE, fr-CH
   *   - domainRegion: nl-BE
   *   - preferredLocale = fr-BE
   *   Because nl-BE has the same region as fr-BE but fits the language of the user better.
   */
  const preferredLocale = supportedLocales.find(locale => {
    return locale.split('-')[1] === domainRegion
  })

  if (!preferredLocale) return null

  return getUrlByLocale(preferredLocale)
}

module.exports = {
  getHostnameByLocale,
  getUrlByLocale,
  getDomainMap,
  getLocaleByDomain,
  getDesiredDomainByLanguage,
}
